import Help from "."; 

export const helpRoutes = () => [
  {
    path: "/helps",
    component: Help,
    layout: "front",
    title: "page",
  },
];